import styled from "styled-components";

export const CategoryText = styled("p")`
  margin-bottom: 0px;
  width: 80%;
  font-family: "Nunito";
  font-size: 14px;
`;

export const CategoryTitle = styled("h5")`
  font-family: "Nunito";
  font-size: 18px;
  font-weight: 700;
  line-height: 22px;
  text-align: center;
  margin-bottom: 0px;
`;

export const CategoryHeader = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  border-bottom: 1px solid #f0f0f0;
`;

export const ButtonCrear = styled("button")`
  width: 50px;
  height: 20px;
  font-size: 12px;
  font-family: "Nunito";
  border-radius: 5px;
  border: solid 1px #22af47;
  cursor: pointer;
  background-color: #fff;
  color: #22af47;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: #22af47;
    color: white;
  }

  &:active {
    background-color: #22af47;
    color: white;
  }
`;
